import React from 'react';
import {ExclamationIcon} from '@heroicons/react/solid'

export default function About() {

  return (
    <div style={{minHeight: '35em'}} className="mx-10 bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200">
      <div className="px-4 py-5 sm:px-6">
        <h2 className="text-2xl mb-10 font-bold pb leading-7 text-gray-900 sm:text-3xl sm:truncate">
          About
        </h2>
      </div>
      <div className="px-4  py-5 sm:p-6">
        <div className="rounded-md max-w-3xl mt-5 bg-yellow-50 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <ExclamationIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800">Attention</h3>
              <div className="mt-2 text-sm text-yellow-700">
                <p>
                  This application is currently in closed testnet. Most functionality will be made available over the next week.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <h2><b>What is closed testnet</b></h2>
          <p className="mt-5 text-lg   max-w-3xl text-gray-900">
            Closed testnet is a read only version of Goracle. During this phase, we work with dApps that will use Algorand to start
            reading from our price oracles, and collect interest from individuals interested in providing feeds and running nodes.
          </p>
          <p className="mt-5 text-lg   max-w-3xl text-gray-900">
            Once dApps are setup and pulling prices from contract&apos;s global state, and we have 5-10 independent feed providers and 30 node runners, we will launch incentivized testnet, where the community at large will be able to interact with the Goracle network.
          </p>
        </div>
        <div className="mt-5">
          <h2><b>What can I do during closed Testnet?</b></h2>
          <p className="mt-5  text-lg   max-w-3xl text-gray-900">
            If you are interested in running nodes, <a style={{color: 'blue'}} href="https://www.goracle.io/contact"> get in touch </a> with our team to join the waitlist for incentivized testnet.
          </p>
        </div>
      </div>
    </div>
  );
}


